/**
 * Article Template Script
 * ------------------------------------------------------------------------------
 * A file that contains code highly coupled to the Article template.
 *
 * @namespace article
 * @file template-article.js
 *
 */

window.theme = window.theme || {};

/*
theme.methods = theme.methods || {};
theme.methods.waitForElement = theme.methods.waitForElement || function (selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }
    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}
*/

theme.maudern = theme.maudern || {};
theme.maudern.article = {
  init: function () {
    if (document.querySelector('body').classList.contains('maudern-article')) {
      theme.maudern.article.articleProducts();
      theme.maudern.article.toggleFooterVisibility();
    }
  },
  toggleFooterVisibility: function () {
    document.addEventListener('scroll', function () {
      if (theme.methods.scrollY() > 0) {
        document.querySelector('.article-header').classList.add('show-image');
      } else {
        document.querySelector('.article-header').classList.remove('show-image');
      }
      if (theme.methods.scrollY() > (document.querySelector('.article-content').clientHeight * 0.75)) {
        if (document.querySelectorAll('.article-footer .article-products').length > 0) {
          document.querySelector('.article-header').classList.add('show-footer');
        }
      } else {
        document.querySelector('.article-header').classList.remove('show-footer');
      }
      if (window.innerWidth <= theme.constants.BREAKPOINTS.small) {
        let image_scale = 1 + (0.5 * (theme.methods.scrollY() / document.querySelector('.article-hero').clientHeight));
        document.querySelector('.article-hero .article-image-img').style.transform = `scale(${image_scale})`;
      }
    }, {
      capture: true,
      passive: true
    });
  },
  articleProducts: function () {
    if (document.querySelectorAll('.article-footer .article-products').length > 0) {
      theme.waitForElement('body.swiper--enabled').then(() => {
        theme.maudern.article.productSilder = new theme.vendor.Swiper('.article-footer', {
          speed: 400,
          slidesPerView: 'auto',
          centeredSlides: false,
          loop: true,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
        });
      });
    }
    if (document.querySelectorAll('.article-products-mobile .article-products').length > 0) {
      theme.waitForElement('body.swiper--enabled').then(() => {
        theme.maudern.article.productSilder = new theme.vendor.Swiper('.article-products-mobile', {
          speed: 400,
          slidesPerView: 'auto',
          centeredSlides: false,
          loop: true,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
        });
      });
    }
  }
}
theme.maudern.article.init();

document.addEventListener('scroll', function () {
  // Navigation reveal
  if (theme.methods.scrollY() > document.querySelector('.article-hero').clientHeight) {
    document.querySelector('body').classList.add('header-menu--shaded');
  } else {
    if (theme.methods.scrollY() < document.querySelector('.article-hero').clientHeight) {
      document.querySelector('body').classList.remove('header-menu--shaded');
    }
  }
});

function openMaudernPopup() {
  if (window.innerWidth >= 750) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'TVWTg3']);
  } else {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'V5Upa9']);
  }
}

document.querySelector('.header__menu-item[data-title="Subscribe"]').addEventListener("click", function (e) {
  e.preventDefault();
  openMaudernPopup();
}, false);

document.querySelector('.menu-drawer__menu-item[data-title="Subscribe"]').addEventListener("click", function (e) {
  e.preventDefault();
  document.querySelector('summary[aria-controls="menu-drawer"]').click()
  openMaudernPopup();
}, false);